import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Image, Message, Container, Modal, Dimmer, Header } from 'semantic-ui-react';
import { ITechnicianCertificatePhoto } from '../../../app/models/techniciancertificatephoto';
import EmployeeCertificateStore from '../../../app/stores/employeecertificateStore';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../app/stores/rootStore';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import CertificatePhotoDropzone from '../../../app/common/Dropzone/CertificatePhotoDropzone';

interface IProps {
  certificate: string;
}

const EmployeeCertificatePhoto: React.FC<IProps> = ({ certificate }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal, openModal} = rootStore.modalStore;
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {
    employeecertificatephotosById,
    deleteEmployeeCertificatePhoto,
    target,
    submitting,
  } = employeecertificateStore;

  const [active, setDimmer] = useState({
    gridid: '',
    status: false
  });

  return (
    <div>
    <Header content={certificate} />
          <Grid  columns='equal' celled>
            { (employeecertificatephotosById.length !== 0) ?
            employeecertificatephotosById.map((employeecertificatephoto) => (
               <Grid.Column key={employeecertificatephoto.id}>
                 {employeecertificatephoto.path.replace(/^.*[\\\/]/, '')}
                {/* <Image
        src={`${techniciancertificatephoto.url}`}
        size='medium'
      />  
      <Button
                  as="a"
                  href={`${techniciancertificatephoto.url}`}
                  download
                  size='mini'
                  content="download"
                  color="blue"
                />
                <Button
                  name={techniciancertificatephoto.id}
                  loading={target === techniciancertificatephoto.id && submitting}
                  size='mini'
                  onClick={() =>  deleteTechnicianCertificatePhoto(techniciancertificatephoto.id).then(
                    () => openModal(<PhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>))}
                  color="red"
                  content="Delete"
                /> */}
      <Dimmer.Dimmable
      //  as={Container}
      dimmed={active.status}
      // dimmer={{ active }}
      onClick={() => setDimmer({['gridid']: employeecertificatephoto.id, ['status']: !active.status })}
      // onMouseLeave={() => setDimmer({['gridid']: employeecertificatephoto.id, ['status']: false })}
      // size='medium'
      // src={`${techniciancertificatephoto.url}`}
    >
      <Image src={(employeecertificatephoto.url.split('.')[1].toUpperCase() === "JPG" || 
      employeecertificatephoto.url.split('.')[1].toUpperCase() === "JPEG" ||
      employeecertificatephoto.url.split('.')[1].toUpperCase() === "PNG") ? 
                    `${employeecertificatephoto.url}` :
                   "/assets/placeholder.png"} size='medium'/>
      <Dimmer active={(active.gridid === employeecertificatephoto.id) && active.status}>
                 <Button
                   as="a"
                  href={`${employeecertificatephoto.url}`}
                  target="_Blank"
                   size='mini'
                   content="Preview"
                   color="green"

                 />
                 <Button
                  name={employeecertificatephoto.id}
                  loading={target === employeecertificatephoto.id && submitting}
                  size='mini'
                  onClick={() =>  deleteEmployeeCertificatePhoto(employeecertificatephoto.id).then(
                    () => openModal(<EmployeeCertificatePhoto certificate={certificate}/>))}
                  color="red"
                  content="Delete"
                />
                 </Dimmer>
    </Dimmer.Dimmable>
    </Grid.Column>
            )) 
            : <Message>No Certificate Photo Uploaded</Message>
           }
      
         </Grid>
         </div>
  );
};

export default EmployeeCertificatePhoto;